const msSecond = 1000;
const msMinute = msSecond * 60;
const msHour = msMinute * 60;
const msDay = msHour * 24;

export function dateDiffDays(date1, date2) {
    let dateDiffMs = Math.abs(date1.getTime() - date2.getTime());

    return Math.round(dateDiffMs / msDay);
}

export function dateDiffNights(date1, date2) {
    return dateDiffDays(date1, date2) - 1;
}

export function addDays(date, days) {
    // add days to the date
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    
    return result;
}

export function addSeconds(date, seconds) {
    let ms = seconds * msSecond;
    var current = new Date(date);
    
    return new Date(current.getTime() + ms);
}

export function addDatePickerDays(date, days) {
    // coerce ISO formated date string to date object
    var current = new Date(date);

    // add days to the date
    var result = new Date(current);
    result.setDate(current.getDate() + days);
    
    // coerce the date object back to an ISO formatted date string
    return toISODateString(result);
}

export function toISODateString(date) {
    if (date == null) {
        return "";
    }
    
    return date.toISOString().substring(0, 10);
}